import { Box, IconButton, TableCell, TableSortLabel, Typography } from '@mui/material';
import { TYPOGRAPHY_WEIGHT } from '../Typography/types';
import React from 'react';
import { TableHeadCellProps } from './types';
import ClearIcon from '@mui/icons-material/Clear';

export const TableHeadCell: React.FC<TableHeadCellProps> = ({
  handleRemoveSortFilter,
  label,
  columnKey,
  orderBy,
  order,
  handleRequestSort,
}) => {
  const isActive = columnKey === orderBy;

  return (
    <TableCell>
      <Box
        sx={{
          display: 'flex',
          gap: 1,
        }}>
        <TableSortLabel
          active={isActive}
          direction={isActive ? order : 'asc'}
          onClick={() => handleRequestSort(columnKey)}>
          <Typography variant="h6" fontWeight={TYPOGRAPHY_WEIGHT.MEDIUM}>
            {label}
          </Typography>
        </TableSortLabel>
        <IconButton
          onClick={handleRemoveSortFilter}
          size="small"
          sx={{
            visibility: isActive ? 'visible' : 'hidden',
            right: 15,
          }}>
          <ClearIcon fontSize="small" color="inherit" />
        </IconButton>
      </Box>
    </TableCell>
  );
};
